import { useEffect } from "react";
import { useStoredState } from "../../hooks";
import { activeModuleId, isGroupOpen, needsReopening, type OpenGroups, withGroupOpen } from "./navModel";
import type { NavGroup } from "./navTypes";

const OPEN_GROUPS_STORAGE_KEY = "nabble.sidebar.groups";

export interface OpenGroupsControl {
  isOpen: (groupId: string) => boolean;
  setOpen: (groupId: string, open: boolean) => void;
}

/** Remembers which modules are open; the module of the current page is always open. */
export function useOpenGroups(nav: NavGroup[], active: string | undefined): OpenGroupsControl {
  const [openGroups, setOpenGroups] = useStoredState<OpenGroups>(OPEN_GROUPS_STORAGE_KEY, {});
  const activeGroup = activeModuleId(nav, active);

  useEffect(() => {
    if (needsReopening(openGroups, activeGroup)) setOpenGroups(withGroupOpen(openGroups, activeGroup, true));
  }, [activeGroup]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isOpen: (groupId) => isGroupOpen(openGroups, groupId),
    setOpen: (groupId, open) => setOpenGroups(withGroupOpen(openGroups, groupId, open)),
  };
}
